import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { usePunditUserContext } from "@circle-react/contexts";
import { useRouteHelpers } from "@circle-react/routes/Main/useRouteHelpers";

export const useShouldShowMobileBottomBar = () => {
  const isMobile = useSmOrMdScreenMediaQuery();
  const { currentCommunityMember } = usePunditUserContext();
  const { isHomePage, isSpaceShowPage, isMemberDirectoryPage, isMessagesPage } =
    useRouteHelpers();

  if (!isMobile) return false;

  return (
    !!currentCommunityMember &&
    (isHomePage || isSpaceShowPage || isMemberDirectoryPage || isMessagesPage)
  );
};
